import { connectHits } from 'react-instantsearch-dom';
import { Box } from '@/components/grid';
import MinicartListing from '@/components/similar-but-safer/components/minicart-listing';
import { filterRawAlgoliaHits } from '@/components/similar-but-safer/utils/filter-raw-algolia-hits';
import {
  QuickCompareHeader,
  ListingsGrid,
} from '@/components/similar-but-safer/components/connected-minicart-listings/styles';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'makeDescription' implicitly has an 'any' type.
export const MinicartListings = ({ makeDescription, modelDescription, year, hits }) => {
  const filteredHits = filterRawAlgoliaHits({ makeDescription, modelDescription, year, hits });
  if (filteredHits.length === 0) {
    return null;
  }

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'className' is missing in type '{ children: Element[]; }' but required in type '{ [x: string]: any; children: any; className: any; }'.
    <Box>
      <QuickCompareHeader as="h2">Quick compare</QuickCompareHeader>
      <ListingsGrid>
        {filteredHits.slice(0, 3).map((hit, index) => (
          <MinicartListing key={hit.objectID} hit={hit} column={index + 1} />
        ))}
      </ListingsGrid>
    </Box>
  );
};

const ConnectedMinicartListings = connectHits(MinicartListings);

export default ConnectedMinicartListings;
